import React, { useState } from 'react';
import './ResultsTable.css';

const ResultsTable = ({ results, isPaid, onExport }) => {
  const [expandedRow, setExpandedRow] = useState(null);

  const toggleRow = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const getVerdictClass = (verdict) => {
    switch (verdict) {
      case 'BUY': return 'verdict-buy';
      case 'WATCH': return 'verdict-watch';
      case 'AVOID': return 'verdict-avoid';
      default: return '';
    }
  };

  const getStageClass = (stage) => {
    switch (stage) {
      case 'Early': return 'stage-early';
      case 'Rising': return 'stage-rising';
      case 'Crowded': return 'stage-crowded';
      case 'Declining': return 'stage-declining';
      default: return '';
    }
  };

  const getGrowthClass = (value) => {
    if (value > 30) return 'growth-green';
    if (value >= 10) return 'growth-yellow';
    return 'growth-red';
  };

  const getProjectionClass = (projection) => {
    const match = projection.match(/(\d+)/);
    if (!match) return '';
    const firstNum = parseInt(match[1]);
    if (firstNum > 60) return 'growth-green';
    if (firstNum >= 20) return 'growth-yellow';
    return 'growth-red';
  };

  const getScoreBarColor = (score, invert = false) => {
    const effective = invert ? 10 - score : score;
    if (effective >= 7) return '#22c55e';
    if (effective >= 4) return '#eab308';
    return '#ef4444';
  };

  if (!results || results.length === 0) return null;

  return (
    <div className="results-table-container">
      <div className="results-table-header">
        <h2>Results <span className="result-count">({results.length})</span></h2>
        {isPaid && onExport && (
          <button onClick={onExport} className="export-btn">
            Export to Excel
          </button>
        )}
      </div>

      <div className="results-table-wrapper">
        <table className="results-table">
          <thead>
            <tr>
              <th className="th-expand"></th>
              <th className="th-name">Name</th>
              <th className="th-score">Score</th>
              <th className="th-verdict">Verdict</th>
              <th className="th-stage">Stage</th>
              <th className="th-growth">30d Growth</th>
              <th className="th-projection">12m Projection</th>
              <th className="th-demand">Demand</th>
              <th className="th-comp">Competition</th>
              <th className="th-monet">Monetisation</th>
              <th className="th-window">Time Window</th>
            </tr>
          </thead>
          <tbody>
            {results.map((item, index) => (
              <React.Fragment key={index}>
                <tr
                  className={`result-row ${expandedRow === index ? 'row-expanded' : ''}`}
                  onClick={() => toggleRow(index)}
                >
                  <td className="td-expand">
                    <span className={`expand-arrow ${expandedRow === index ? 'expanded' : ''}`}>&#9654;</span>
                  </td>
                  <td className="td-name">{item.name}</td>
                  <td className="td-score">
                    <div className="score-display">
                      <span className="score-number">{item.opportunityScore}</span>
                    </div>
                  </td>
                  <td className="td-verdict">
                    <span className={`verdict-badge ${getVerdictClass(item.verdict)}`}>
                      {item.verdict}
                    </span>
                  </td>
                  <td className="td-stage">
                    <span className={`stage-badge ${getStageClass(item.stage)}`}>
                      {item.stage}
                    </span>
                  </td>
                  <td className={`td-growth ${getGrowthClass(item.growth30d)}`}>
                    +{item.growth30d}%
                  </td>
                  <td className={`td-projection ${getProjectionClass(item.growthProjection12m)}`}>
                    {item.growthProjection12m}
                  </td>
                  <td className="td-mini-score">
                    <div className="mini-score-bar">
                      <div
                        className="mini-score-fill"
                        style={{
                          width: `${item.demandScore * 10}%`,
                          background: getScoreBarColor(item.demandScore),
                        }}
                      ></div>
                    </div>
                    <span className="mini-score-val">{item.demandScore}</span>
                  </td>
                  <td className="td-mini-score">
                    <div className="mini-score-bar">
                      <div
                        className="mini-score-fill"
                        style={{
                          width: `${item.competitionScore * 10}%`,
                          background: getScoreBarColor(item.competitionScore, true),
                        }}
                      ></div>
                    </div>
                    <span className="mini-score-val">{item.competitionScore}</span>
                  </td>
                  <td className="td-mini-score">
                    <div className="mini-score-bar">
                      <div
                        className="mini-score-fill"
                        style={{
                          width: `${item.monetisationScore * 10}%`,
                          background: getScoreBarColor(item.monetisationScore),
                        }}
                      ></div>
                    </div>
                    <span className="mini-score-val">{item.monetisationScore}</span>
                  </td>
                  <td className="td-window">{item.timeWindow}</td>
                </tr>
                {expandedRow === index && (
                  <tr className="expanded-row">
                    <td colSpan="11">
                      <div className="expanded-content">
                        <div className="expanded-grid">
                          <div className="expanded-block">
                            <h4>Why Now</h4>
                            <p>{item.whyNow}</p>
                          </div>
                          <div className="expanded-block">
                            <h4>Suggested Angle</h4>
                            <p>{item.suggestedAngle}</p>
                          </div>
                          <div className="expanded-block expanded-block-full">
                            <h4>Deep Explanation</h4>
                            <p>{item.deepExplanation}</p>
                          </div>
                        </div>
                        <p className="projection-disclaimer">* 12-month projection is a modelled estimate.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ResultsTable;
